/**
 * Identificador da venda para consultas publicas (/detalhes-venda, polling do
 * PIX, pre-agendamento de portabilidade).
 *
 * A API devolve o `uuid` publico ao lado do `id` sequencial; o id deixara de ser
 * aceito nessas rotas (incidente de 19/10: enumeracao pelo id). O id so fica como
 * reserva para o caso de a API nao devolver o uuid.
 */
interface SaleResponse {
  id?: string | number
  uuid?: string | null
  info?: { id?: string | number; uuid?: string | null }
}

export function publicSaleId(response: SaleResponse | undefined, virtualChip: boolean): string | number | undefined {
  if (!response) return undefined

  return virtualChip
    ? response.info?.uuid || response.info?.id
    : response.uuid || response.id
}

const SALE_ID = /^(\d+|[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})$/i

/** id numerico (transicao) ou uuid publico. */
export function isSaleIdentifier(value: unknown): boolean {
  return SALE_ID.test(String(value ?? '').trim()) && String(value).trim() !== '0'
}
